import moment from 'moment-timezone';

export interface MaintenanceWindow {
  endTime: string;
  sameDay: boolean;
  startTime: string;
  timezone: string;
}

export function isInMaintenance(maintenanceWindow: MaintenanceWindow): boolean {
  const endTime: string = maintenanceWindow && maintenanceWindow.endTime ? maintenanceWindow.endTime : '05:00:00';
  const sameDay: boolean = maintenanceWindow && maintenanceWindow.sameDay ? maintenanceWindow.sameDay : false;
  const startTime: string = maintenanceWindow && maintenanceWindow.startTime ? maintenanceWindow.startTime : '23:00:00';
  const timezone: string = maintenanceWindow && maintenanceWindow.timezone ? maintenanceWindow.timezone : 'America/New_York';
  const timeFormat = 'HH:mm:ss';
  const easternTime = moment.tz(timezone).format(timeFormat);

  return (sameDay && moment(easternTime, timeFormat).isSameOrAfter(moment(startTime, timeFormat), 'hour')
    && moment(easternTime, timeFormat).isBefore(moment(endTime, timeFormat), 'hour'))
    || (!sameDay && (moment(easternTime, timeFormat).isSameOrAfter(moment(startTime, timeFormat), 'hour')
    || moment(easternTime, timeFormat).isBefore(moment(endTime, timeFormat), 'hour')));
}
